'use strict'

require('../helpers/jquery.textWidth')

var EVENT_NS = '.primary-nav'
var BLOCK_CLASS = 'primary-nav'
var BLOCK_SELECTOR = '.' + BLOCK_CLASS
var MENU_CLASS = BLOCK_CLASS + '__menu'
var MENU_SELECTOR = '.' + MENU_CLASS
var OPEN_MENU_CLASS = MENU_CLASS + '--open'
var BLOCK_FULL_CLASS = 'primary-nav--full'
var ITEM_CLASS = BLOCK_CLASS + '__item'
var ITEM_SELECTOR = '.' + ITEM_CLASS
var OPEN_ITEM_CLASS = BLOCK_CLASS + '__item--open'
var OPEN_ITEM_SELECTOR = '.' + OPEN_ITEM_CLASS
var CURRENT_ITEM_CLASS = ITEM_CLASS + '--current'
var CURRENT_ITEM_SELECTOR = '.' + CURRENT_ITEM_CLASS
var CURRENT_PARENT_ITEM_CLASS = ITEM_CLASS + '--current-parent'
var CURRENT_PARENT_ITEM_SELECTOR = '.' + CURRENT_PARENT_ITEM_CLASS
var CURRENT_ANCESTOR_ITEM_CLASS = ITEM_CLASS + '--current-ancestor'
var CURRENT_ANCESTOR_ITEM_SELECTOR = '.' + CURRENT_ANCESTOR_ITEM_CLASS
var UNDERLINED_ITEM_CLASS = ITEM_CLASS + '--underlined'
var HAS_CHILDREN_ITEM_SELECTOR = ITEM_SELECTOR + '--has-children'
var LINK_SELECTOR = BLOCK_SELECTOR + '__link'
var UNDERLINE_CLASS = BLOCK_CLASS + '__underline'

var PrimaryNav = function(el) {
	this.el = (el instanceof jQuery) ? el[0] : el
	this.$el = $(el);
	this.$el.data('PrimaryNav', this)

	this.singularizeCurrentItem()

	this.$menu = $(MENU_SELECTOR, this.el)
	this.$rootItems = this.$menu.children(ITEM_SELECTOR)
	this.$activeRootItem = this.$rootItems
		.filter(function() {
			return (
				$(this).is(CURRENT_ITEM_SELECTOR) ||
				$(this).is(CURRENT_PARENT_ITEM_SELECTOR) ||
				$(this).is(CURRENT_ANCESTOR_ITEM_SELECTOR)
			)
		})
	this.$activeRootItem.addClass(UNDERLINED_ITEM_CLASS)
	this.$activeRootLink = this.$activeRootItem.children(LINK_SELECTOR)
	this.$openRootItem = this.$rootItems.filter(OPEN_ITEM_SELECTOR)
}

Object.assign(PrimaryNav, {
	EVENT_MODIFIER_CHANGED: 'changed:modifier' + EVENT_NS,
	EVENT_MENU_TOGGLE: 'toggle:menu' + EVENT_NS
})

Object.assign(PrimaryNav.prototype, {
	init: function() {
		this.defaultLinkPadding = $(LINK_SELECTOR + ':first', this.el).css('padding-left')

		// init underline
		this.$underline = $('<div class="' + UNDERLINE_CLASS + '"/>')
			.hide()
			.appendTo(this.el)

		this.attachEventHandlers()
		this.update()
		this.uncollapseToCurrentItem()

		return this
	},
	attachEventHandlers: function() {
		$(this.el).on('click', LINK_SELECTOR, $.proxy(this.onClickLink, this))
		$(document).on('click', $.proxy(this.onClickDocument, this))
		$(window).on('resize', _.throttle(_.bind(this.onWindowResize, this), 400))

		this.$el.on('mouseenter', MENU_SELECTOR + '>' + ITEM_SELECTOR, $.proxy(this.onMouseEnterRootItem, this))
	},
	singularizeCurrentItem: function() {
		var $items = $(ITEM_SELECTOR, this.el)
		var $current = $items.filter(CURRENT_ITEM_SELECTOR).eq(0)
			.removeClass(CURRENT_PARENT_ITEM_CLASS)
			.removeClass(CURRENT_ANCESTOR_ITEM_CLASS)

		if (!$current.length)
			return

		var branch = [$current[0]]
		var $parent = $current.parent()
		for (var i = 0; $parent[0] != this.el && $parent.length; i++) {
			if ($parent.hasClass(ITEM_CLASS)) {
				$parent.removeClass(CURRENT_ITEM_CLASS)
				if (i == 0) {
					$parent
						.removeClass(CURRENT_ANCESTOR_ITEM_CLASS)
						.addClass(CURRENT_PARENT_ITEM_CLASS)
				} else {
					$parent
						.removeClass(CURRENT_PARENT_ITEM_CLASS)
						.addClass(CURRENT_ANCESTOR_ITEM_CLASS)
				}
				branch.push($parent[0])
			}
			$parent = $parent.parent()
		}

		$items.each(function() {
			if (branch.indexOf(this) < 0) {
				$(this)
					.removeClass(CURRENT_ITEM_CLASS)
					.removeClass(CURRENT_ANCESTOR_ITEM_CLASS)
					.removeClass(CURRENT_PARENT_ITEM_CLASS)
			}
		})
	},
	uncollapseToCurrentItem: function() {
		var $items = $(CURRENT_ANCESTOR_ITEM_SELECTOR, this.el)
			.add($(CURRENT_PARENT_ITEM_SELECTOR, this.el))
		if (this.inFullMode()) {
			$items = $items.not(this.$rootItems)
		}
		$items.addClass(OPEN_ITEM_CLASS)
	},
	detachClientEventHandlers: function() {
		this.$el.off(EVENT_NS)
	},
	onMouseEnterRootItem: function(e) {
		if (this.inFullMode()) {
			// Close root items except the current one
			var $item = this.$openRootItem.not(e.currentTarget)
			if ($item.length) {
				this.closeItem($item)
			}
		}
	},
	onClickLink: function(e) {
		var $link = $(e.currentTarget)
		var $item = $link.closest(ITEM_SELECTOR)

		if ($item.parent(MENU_SELECTOR).length) { // root item
			this.$activeRootLink = $link
			this.$activeRootItem = $item
			this.$activeRootItem
				.addClass(UNDERLINED_ITEM_CLASS)
				.toggleClass(OPEN_ITEM_CLASS)
				.siblings()
					.removeClass(UNDERLINED_ITEM_CLASS)
					.removeClass(OPEN_ITEM_CLASS)
			this.$openRootItem = $item.filter(OPEN_ITEM_SELECTOR)
			this.updateUnderlineGeometry(true)
		} else { // submenu item
			if ($item.is(HAS_CHILDREN_ITEM_SELECTOR)) {
				e.preventDefault() // don't follow link
				$item
					.toggleClass(OPEN_ITEM_CLASS)
					.siblings()
						.removeClass(OPEN_ITEM_CLASS)
			}
		}
	},
	onClickDocument: function(e) {
		var $item = $(e.target).closest(ITEM_SELECTOR)
		var itemHasSubMenu = $item.is(HAS_CHILDREN_ITEM_SELECTOR)
		
		var clickFromRootItem = $item.length && $item.parent(MENU_SELECTOR).length
		var clickFromSubmenuItem = $item.length && !clickFromRootItem
		
		var inFullMode = this.inFullMode()
		
		if (inFullMode && !clickFromRootItem && !(clickFromSubmenuItem && itemHasSubMenu)) {
			this.closeItem(this.$openRootItem)
		}
		if (!inFullMode && !(clickFromRootItem && itemHasSubMenu) && !(clickFromSubmenuItem && itemHasSubMenu)) {
			this.toggleMenu(false)
		}
	},
	onWindowResize: function() {
		this.$rootItems.removeClass(OPEN_ITEM_CLASS)
		this.update()
	},
	/**
	 * This must be called after each programmatical content change
	 * (adding/removing item, restyling, etc).
	 */
	update: function() {
		this.updateMinContentWidth()
		this.updateClassToFitContent()
		this.updateUnderlineGeometry()
	},
	closeItem: function(el) {
		$(el).removeClass(OPEN_ITEM_CLASS)
		this.$openRootItem = this.$openRootItem.not(el)
	},
	updateUnderlineGeometry: function(animate) {
		if (this.$activeRootItem.length && this.inFullMode()) {
			var linkLeft = this.$activeRootLink.offset().left - this.$el.offset().left
			var linkWidth = this.$activeRootLink.outerWidth()
			var textWidth = this.$activeRootLink.textWidth()
			var left = Math.round(linkLeft + (linkWidth - textWidth) / 2)
			var props = {
				left: left + 'px',
				width: textWidth + 'px'
			}
			if (animate) {
				this.$underline.animate(props, 100)
			} else {
				this.$underline.show().css(props)
			}
		} else {
			this.$underline.hide();
		}
	},
	updateMinContentWidth: function() {
		var minWidth = 0;
		var $test = $('<div/>')
			.css({'position': 'absolute'})
			.appendTo(document.body)

		this.$rootItems.each($.proxy(function(index, el) {
			var $link = $(el).children(LINK_SELECTOR)
			$test.css({
				'padding-left': this.defaultLinkPadding,
				'padding-right': this.defaultLinkPadding,
				'font-family': $link.css('font-family'),
				'font-size': $link.css('font-size')
			})
			$test.html($link.html())
			minWidth += $test.outerWidth()
		}, this))

		$test.remove()
		this.minContentWidth = minWidth
	},
	inFullMode: function() {
		return this.$el.hasClass(BLOCK_FULL_CLASS)
	},
	updateClassToFitContent: function() {
		var toAdd = this.$el.outerWidth() >= this.minContentWidth
		var added = this.$el.hasClass(BLOCK_FULL_CLASS)
		if (added != toAdd) {
			this.$el.toggleClass(BLOCK_FULL_CLASS, toAdd)
			this.$el.trigger(PrimaryNav.EVENT_MODIFIER_CHANGED, {
				modifier: 'full',
				full: toAdd
			})
		}
	},
	toggleMenu: function(open, options) {
		this.$menu.toggleClass(OPEN_MENU_CLASS, open)
		var silent = options && options.silent
		if (!silent) {
			this.$el.trigger(PrimaryNav.EVENT_MENU_TOGGLE)
		}
	},
	isMenuOpen: function() {
		return this.$menu.hasClass(OPEN_MENU_CLASS)
	}
})

module.exports = PrimaryNav


/*****************
 ** WEBPACK FOOTER
 ** ./components/PrimaryNav.js
 ** module id = 158
 ** module chunks = 0
 **/